import { HeroSection } from "@/components/HeroSection.tsx";
import { RightsAccordion } from "@/components/RightsAccordion.tsx";
import { InfoCards } from "@/components/InfoCards.tsx";
import { HowWeHelp } from "@/components/HowWeHelp.tsx";
import { Reviews } from "@/components/Reviews.tsx";
import { Footer } from "@/components/Footer.tsx";
import { WhyChooseUs } from "@/components/WhyChooseUs.tsx";
import { Logo } from "@/components/Logo.tsx";
import { Copyright } from "@/components/Copyright.tsx";
import { LanguageSwitcher } from "@/components/LanguageSwitcher.tsx";
import { SEOStructuredData } from "@/components/SEOStructuredData.tsx";
import {Consultation} from "@/components/Consultation.tsx";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Index = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'zh')) {
            i18n.changeLanguage(lang);
        } else {
            navigate('/landing-page/en', { replace: true });
        }
    }, [lang, i18n, navigate]);
  
  return (
    <div className="min-h-screen bg-[#1A2B3C]">
        <Helmet>
            <html lang={i18n.language} />
            <title>{t('seo.title')}</title>
            <meta name="description" content={t('seo.description')} />
            <meta name="keywords" content={t('seo.keywords')} />
            <link rel="icon" type="image/x-icon" href="./favicon.ico" /> {/* 添加 favicon */}
        </Helmet>
        <SEOStructuredData />
        <header className="bg-[#ffffff] py-4">
            <div className="container mx-auto px-4 flex justify-between items-center">
                <Logo />
                <LanguageSwitcher />
            </div>
        </header>
        <HeroSection />
        <InfoCards />
        <RightsAccordion />
        <Consultation />
        <HowWeHelp />
        <WhyChooseUs />
        {/*<Reviews />*/}
        <Consultation />
        <Footer />
        <Copyright />
    </div>
  );
};

export default Index;